import * as z from 'zod'

import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const payment = () =>
  ({
    schema: z.object({}).passthrough(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.payment.choose_method',
        },
      },
      {
        type: 'customComponent',
        name: 'StepPayment',
        inputs: [],
        outputs: [],
        props: {},
      },
    ],
    subFlow: SubFlow.PaymentAndConfirmation,
    nextStep: 'legal_documents_email',
    showOrderSummary: true,
  }) as const satisfies AnyStepConfiguration

export default payment
